import { useEffect } from "react";
import { ActorType } from "../utils/helpers/getActorType";

export const useDocumentBranding = (actorType: ActorType) => {
  useEffect(() => {
    const isAgent = actorType === "salesAgent";
    document.title = isAgent ? "Sales Portal" : "Admin Panel";
    document.body.classList.toggle("theme-agent", isAgent);

    const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (favicon) favicon.href = isAgent ? "/sales_agent.svg" : "/save_in_gold.svg";
  }, [actorType]);
};